<template>
  <el-dialog
    :visible="visible"
    @close="$emit('update:visible', false)"
    width="900px"
    :close-on-click-modal="false"
    custom-class="detail-data"
  >
    <div
      slot="title"
      class="Diatitle"
    >
      <span>设备详情</span>
    </div>
    <div class="detail-info">
      <div v-for="(item,index) in homeData" :key="index" class="detail-info-item">
        <div class="label">
          {{ item.label }}
        </div>
        <div v-if="selectMonitorInfo" class="center">{{ selectMonitorInfo[item.key] }}</div>
      </div>
      <div class="detail-info-line"></div>
    </div>
  </el-dialog>
</template>

<script>
import { homeData } from '@/assets/js/registerType.js';
export default {
  name:'EquipmentDetails',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    selectMonitorInfo: {
      type: Object,
      default: () => {}
    },
  },

  data() {
    return {
      homeData:homeData.filter(item => item.type !== 'object' && item.type !== 'array')
    };
  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin.scss';
::v-deep .detail-data{
  z-index: 2010;
}
::v-deep .el-dialog__body {
  padding: 20px 0 20px !important;
}
::v-deep .el-dialog__headerbtn {
  top: 12px !important;
}
.padding{
  border-top: 2px solid #EBEEF5;
  margin-top: 20px;
}
.detail-info{
  @include scrollBar;
  max-height: 400px;
  overflow-y: auto;
  padding: 14px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-content: flex-start;
  &-item,.card-item{
    width: 50%;
    box-sizing: border-box;
    border: 1px solid #EBEEF5;
    border-bottom: none;
    >.label,.card-item-label{
      background: #fafafa;
      padding: 14px;
      border-bottom: 1px solid #EBEEF5;
    }
    >.center,.card-item-center{
      padding: 14px;
    }
  }
  .card-item{
    border-bottom: 1px solid #EBEEF5;
  }
  &-line{
    width: 100%;
    border-top: 1px solid #EBEEF5;
  }
  &-card{
    width: 100%;
    .label{
      font-size: 18px;
      font-family: 'PingFang SC';
      font-weight: bold;
      color: #000;
      margin: 14px 0;
    }
    .center{
      border: 1px solid #EBEEF5;
      padding: 14px;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
    }
  }
  .cursor{
    cursor: pointer;
  }
}
.Diatitle {
  width: 100%;
  height: 42px;
  background-color: #f6f6f6;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  span {
    padding: 0 20px;
    font-size: 18px;
    font-family: 'PingFang SC';
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }
}
</style>
